import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-8">
      <div className="border-2 border-ink bg-paper p-6 shadow-stamp text-center">
        <h1 className="font-display text-3xl text-ink mb-2">404</h1>
        <p className="font-mono text-ink">{t('errors.noRestaurant')}</p>
      </div>
    </div>
  );
}
